import parser from 'ua-parser-js';

const getDeviceInfo = () => {
    window._deviceInfo = parser(navigator.userAgent);
}

export default getDeviceInfo;